const EM_DASH = "—";

export function formatCurrencyINR(value?: number | null): string {
  if (value == null || Number.isNaN(value)) return EM_DASH;
  return `₹${value.toLocaleString("en-IN")}`;
}

export function formatDate(iso?: string | null): string {
  if (!iso) return EM_DASH;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return EM_DASH;
  return d.toLocaleDateString("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
}

export function formatBoolean(value?: boolean | null): string {
  if (value == null) return EM_DASH;
  return value ? "Yes" : "No";
}

export function formatText(value?: string | number | null): string {
  if (value == null || value === "") return EM_DASH;
  return String(value);
}

export function formatEmailList(emails?: string[]): string {
  if (!emails || emails.length === 0) return EM_DASH;
  return emails.join(", ");
}
